import styled from 'styled-components';

export const Container = styled.div`
  width: 936px;
  & .data-header {
    position: sticky;
    top: 0;
    z-index: 2;
    color: #3b3b3bb3;
  }
  & .data-row {
    padding: 24px 30px;
    display: inline-flex;
    flex-flow: row wrap;
    width: 100%;
    &.data-header {
      display: flex;
    }
    & .data-column {
      flex: 1;
      padding: 0 45px 0 0;
      z-index: 1;
      position: relative;
    }
  }
  & .data-content {
    & .data-row {
    }
`;
